module.exports = __webpack_public_path__ + "static/media/treeBranch.c5887b86.png";